import { create } from "zustand";
import { persist } from "zustand/middleware";
import api from "@/lib/api";
import type { Country } from "@/types";

interface CountryState {
  countries: Country[];
  isLoading: boolean;
  fetchCountries: () => Promise<void>;
}

export const useCountryStore = create<CountryState>()(
  persist(
    (set, get) => ({
      countries: [],
      isLoading: false,

      fetchCountries: async () => {
        if (get().countries.length > 0) return;
        set({ isLoading: true });
        try {
          const { data } = await api.get<{ data: Country[] }>("/countries");
          set({ countries: data.data, isLoading: false });
        } catch {
          set({ isLoading: false });
        }
      },
    }),
    {
      name: "country-storage",
      partialize: (state) => ({ countries: state.countries }),
    },
  ),
);
